
import React, { useEffect, useState } from 'react';
import AnimatedText from './AnimatedText';
import { ArrowRight } from 'lucide-react';
import presentationBg from '@/assets/presentation-bg.jpg';

const Hero: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center pt-16 overflow-hidden bg-[#1a2332]"
    >
      {/* Presentation background image */}
      <div 
        className="absolute inset-0 -z-10 opacity-[0.08]"
        style={{
          backgroundImage: `url(${presentationBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      />
      
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#1a2332] via-[#253447] to-[#1a2332] -z-10" />
      
      {/* Transparent background pattern */}
      <div className="absolute inset-0 opacity-[0.03] -z-10" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        backgroundSize: '60px 60px'
      }} />

      <div className="container mx-auto px-6 pt-16 md:pt-24 pb-8 md:pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto">
          <div>
            {/* Headline */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-balance">
              <span className="text-reveal-container block mb-2">
                <span className={`block transition-all duration-700 delay-100 text-white ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-8'}`}>
                  Craft <span className="text-presintention-accent">Presentations</span>
                </span>
              </span>
              <span className="text-reveal-container block">
                <span className={`block transition-all duration-700 delay-200 text-white ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-8'}`}>
                  That Inspire Action.
                </span>
              </span>
            </h1>
            
            {/* Subheadline */}
            <p className={`text-base md:text-lg text-gray-300 max-w-xl mb-10 leading-relaxed transition-all duration-700 delay-300 ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-8'}`}>
              Transform your public speaking with expert coaching that builds confidence, clarity, and charisma. Discover the techniques that captivate audiences and drive results.
            </p>
            
            {/* CTA Button */}
            <div className={`flex flex-wrap gap-4 transition-all duration-700 delay-400 ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-8'}`}>
              <a
                href="/#contact"
                className="inline-flex items-center justify-center px-8 py-3.5 bg-presintention-accent text-white rounded-lg hover:bg-opacity-90 transition-all button-transition hover-lift text-base font-semibold shadow-lg"
              >
                Get started
              </a>
            </div>
          </div>
          
          {/* Hero Image */}
          <div className={`relative transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'}`}>
            <div className="relative">
              {/* Decorative gold border frame */}
              <div className="absolute -top-4 -left-4 w-full h-full border-[3px] border-presintention-accent rounded-lg z-0" />
              
              {/* Image container */}
              <div className="relative bg-[#2a3847] rounded-lg overflow-hidden shadow-2xl">
                <img 
                  src="/lovable-uploads/8a1d8ca9-a01f-4aae-9ab9-2d6d648a37c1.png" 
                  alt="Alex Fairlie - Professional presentation coach" 
                  className="relative z-10 w-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </section>
  );
};

export default Hero;
